export const docIdToFriendlyName = {
  A_AMND: 'Auto Policy Amendatory Endorsement',
  A_APPL: 'Auto Application',
  A_APTA: 'Automobile Policy Term Acknowledgement Form',
  A_BIOF: 'Bodily Injury Option and Premiums',
  A_BISF: 'Choice of Bodily Injury Liability Coverage Limits',
  A_CNPY: 'Cancellation Notice',
  A_CNREL: 'Cancellation Notice',
  A_CNRET: 'Cancellation Notice',
  A_CNREV: 'Cancellation Notice',
  A_CNRS: 'Cancellation Notice',
  A_CODW: 'Collision Deductible Waiver',
  A_DRAT: 'Unverified Driver Attestation',
  A_DECK: 'Auto Declarations',
  A_DECLL: 'Declination Notice',
  A_DECLT2: 'Declination Notice',
  A_DECLT: 'Declination Notice',
  A_DECLV: 'Declination Notice',
  A_DITR: 'Declaration of Intent to Reside',
  A_ICSE: 'Insurance Consultation Services Exemption',
  A_IDCD: 'Auto ID Cards',
  A_MRMV: 'Massachusetts RMV Insurance Certification',
  A_INNO: 'Important Insurance Notice',
  A_LOIW: 'Loss of Income Waiver',
  A_MEDP: 'MedPay Selection/Rejection Form',
  A_MPSF: 'Selection of Personal Injury Protection',
  A_NDEL: 'Named Driver Exclusion Election Form',
  A_NDEX: 'Named Driver Exclusion',
  A_NNOP: 'Named Non-Owner Coverage Endorsement',
  A_IACH: 'Illinois Amendatory Endorsement - Consumer Hotline',
  A_NOBE: 'Notice of Benefits',
  A_NOTO: 'Notice of Tort Options',
  A_NPRCT: 'Rescission Notice',
  // The BIX-conversion non-renewal generation pipeline was removed (gobranch/branch#31073, #31350),
  // but historic policies still reference _A_NRBIX/_H_NRBIX documents stored in S3. Keep these label
  // lookups so those documents resolve a friendly name in customer/staff doc listings.
  A_NRBIX: 'Insurance Cancellation Notice',
  A_NRRS: 'Non-Renewal Notice',
  A_NULL: 'Null Contract',
  A_PIPR: 'Pet Injury Endorsement',
  A_PIPS: 'Notice of Waiver of Personal Injury Protection',
  A_PJAK: 'Auto Policy',
  A_PLCY: 'Auto Policy',
  A_PSDS: 'Surcharge Disclosure',
  A_RENT: 'Renters Endorsement',
  A_RIDE: 'Rideshare Endorsement',
  A_SFSW: 'Auto Stress-Free Switch Letter',
  A_SMCQ: 'State Minimum Coverage Quote',
  A_TOSF: 'Tort Selection Rejection Form',
  A_UIMS: 'UIM Selection Rejection Form',
  A_POSF: 'Florida Selection of Personal Injury Protection',
  A_UMNF: 'Notice Regarding UMPD',
  A_UMRJ: 'UM Rejection Form',
  A_UIMR: 'UIM Rejection Form',
  A_UMSF: 'UM or UM/UIM Selection Rejection Form',
  A_WGPT: 'Window Glass Coverage Endorsement',
  A_WLBW: 'Work Loss Benefits Waiver',
  B_AUTH: 'Recurring Payment Authorization',
  A_MEDS: 'Driver Medical Statement',
  A_PHYS: 'Doctor / Physician Statement',
  B_SASP: 'Subscriber Agreement Signature Page',
  BRANCH_AUTO_ID_CARDS: 'Auto ID Cards',
  H_AAVK: 'Adverse Action Decision Notice',
  H_ACSF: 'Additional Coverage Offerings',
  H_AMND: 'Home Policy Amendatory Endorsement',
  H_ANME: 'Animal Liability Exclusion',
  H_ANML: 'Animal Liability Limitation Endorsement',
  H_APPL: 'Homeowners Application',
  H_BIND: 'Home Insurance Proof of Insurance',
  H_CMSL: 'Coal Mine Subsidence Waiver',
  H_CNPY: 'Cancellation Notice',
  H_CNRN: 'Insurance Cancellation Notice',
  H_CNRS: 'Cancellation Notice',
  H_DECK: 'Homeowners Declarations',
  H_DISC: 'Notice of Availability of Discounts',
  H_DPUA: 'Homeowners Personal Umbrella Liability Declarations Addendum',
  H_EUSF: 'Excess UM/UIM Motorists Selection/Rejection Form',
  H_EXPA: 'Explanatory Notice',
  H_FCRA: 'Adverse Action Decision Notice',
  H_FLOX: 'Flood Notice',
  H_IB10: 'Increased Building Structure Protection 10% Endorsement',
  H_IB25: 'Increased Building Structure Protection 25% Endorsement',
  H_INVC: 'Escrow Invoice',
  H_LADN: 'Louisiana Deductible Notice',
  H_MINA: 'Mine Subsidence Insurance Underwriting Association Application',
  H_MINE: 'Mine Subsidence Endorsement',
  H_MNSF: 'Mine Subsidence Selection Rejection Form',
  // See A_NRBIX above: kept for historic stored-document label resolution after #31073/#31350.
  H_NRBIX: 'Insurance Cancellation Notice',
  H_NRREV: 'Non-Renewal Notice',
  H_NRRS: 'Non-Renewal Notice',
  H_NULL: 'Null Contract',
  H_PJAK: 'Homeowners Policy',
  H_PLCY: 'Homeowners Policy',
  H_PUMB: 'Personal Umbrella Liability Endorsement',
  H_RCEL: 'Home Replacement Cost Estimate Letter',
  H_RENI: 'Fair Rental Income Endorsement',
  H_ROFE: 'Roof Surfaces Extended Coverage',
  H_ROFM: 'Metal Roof Surfaces Cosmetic Damage Exclusion',
  H_ROOF: 'Roof Surfaces Endorsement',
  H_SEWX: 'DC Sewer Notice',
  H_SFSW: 'Home Stress-Free Switch Letter',
  H_SHAR: 'Home Data Sharing Authorization',
  H_SPPE: 'Scheduled Personal Property ',
  H_WHXX: 'Wind/Hail Exclusion Form',
  H_WNHD: 'Windstorm and Hail Deductible Endorsement',
  H_WTBU: 'Water Backup Endorsement',
  R_AMND: 'Renters Policy Amendatory Endorsement',
  R_APPL: 'Renters Application',
  R_CNPY: 'Cancellation Notice',
  R_CNRS: 'Cancellation Notice',
  R_DECK: 'Renters Declarations',
  R_NRRS: 'Non-Renewal Notice',
  R_PJAK: 'Renters Policy',
  R_PLCY: 'Renters Policy',
  R_SFSW: 'Renters Stress-Free Switch Letter',
  C_APPL: 'Condo Application',
  C_MINA: 'Mine Subsidence Insurance Underwriting Association Application',
  C_DECK: 'Condo Declarations',
  C_PJAK: 'Condo Policy',
  C_WTBU: 'Water Backup Endorsement',
  C_DPUA: 'Condo Personal Umbrella Liability Declarations Addendum',
  C_PUMB: 'Personal Umbrella Liability Endorsement',
  R_SPPE: 'Scheduled Personal Property',
  C_SPPE: 'Scheduled Personal Property',
  C_INVC: 'Escrow Invoice',
  C_BIND: 'Condo Insurance Proof of Insurance',
  C_AMND: 'Condo Policy Amendatory Endorsement',
  F_APPL: 'Farmowners Application',
  F_PJAK: 'Farmowners Policy',
  F_DECK: 'Farmowners Declarations',
  F_INVC: 'Farmowners Invoice',
  Z_APPL: 'Homeowners Application',
  Z_PJAK: 'Homeowners Policy',
  Z_DECK: 'Homeowners Declarations',
  Z_INVC: 'Homeowners Invoice',
  // FarmHome policies emit their invoice under the X_INVC template id
  // (FARM_INVOICE_TEMPLATE_ID_BY_POLICY_TYPE), even though their other docs use the Z_* (Homeowners)
  // codes — so this shares the 'Homeowners Invoice' label rather than showing the raw filename (#34203).
  X_INVC: 'Homeowners Invoice',
  Y_APPL: 'Tenant-Occupied Rental Application',
  Y_PJAK: 'Renters Policy',
  Y_DECK: 'Renters Declarations',
  Y_INVC: 'Renters Invoice',
  // Farm Binder Proof of Insurance + Replacement Cost Estimate letter, per composition (#30463).
  F_BIND: 'Farmowners Binder Proof of Insurance',
  Z_BIND: 'Homeowners Binder Proof of Insurance',
  Y_BIND: 'Renters Binder Proof of Insurance',
  F_RCEL: 'Farmowners Replacement Cost Estimate Letter',
  Z_RCEL: 'Homeowners Replacement Cost Estimate Letter',
  Y_RCEL: 'Renters Replacement Cost Estimate Letter',
  // Farm (CFM / Forreston) policy-lifecycle notices (#34574). One Zywave template per brand renders
  // all three compositions; the F / X / Y prefix (FarmHome = X, mirroring F_CNCL/X_CNCL/Y_CNCL from
  // #34153) only labels the stored PDF. Company / Fair-Plan / Non-Pay cancellation all display as
  // "Cancellation Notice", matching the existing A_CNPY/A_CNRS convention.
  F_CCAN: 'Cancellation Notice',
  X_CCAN: 'Cancellation Notice',
  Y_CCAN: 'Cancellation Notice',
  F_FPCN: 'Cancellation Notice',
  X_FPCN: 'Cancellation Notice',
  Y_FPCN: 'Cancellation Notice',
  F_NPAY: 'Cancellation Notice',
  X_NPAY: 'Cancellation Notice',
  Y_NPAY: 'Cancellation Notice',
  F_NRNW: 'Non-Renewal Notice',
  X_NRNW: 'Non-Renewal Notice',
  Y_NRNW: 'Non-Renewal Notice',
  F_NSFV: 'NSF Void Notice',
  X_NSFV: 'NSF Void Notice',
  Y_NSFV: 'NSF Void Notice',
  F_ROFR: 'Policy Reinstatement Offer',
  X_ROFR: 'Policy Reinstatement Offer',
  Y_ROFR: 'Policy Reinstatement Offer',
  F_REIN: 'Reinstatement Notice',
  X_REIN: 'Reinstatement Notice',
  Y_REIN: 'Reinstatement Notice',
  F_AORC: 'Agent of Record Letter',
  X_AORC: 'Agent of Record Letter',
  Y_AORC: 'Agent of Record Letter'
};

// Friendly labels that mark a document as a cancellation / non-renewal notice. These are the only
// member documents the Lob mailing path (docs-engine lob-queue-processor) physically mails, so they
// are the only ones eligible for the staff "Send to member" LETTER channel (#36066). Keyed off the
// shared label so every brand / policy-type code that maps to one of these notices is covered
// automatically (e.g. A_CNRS, H_CNRN, R_NRRS, X_NPAY, ...).
const CANCELLATION_NON_RENEWAL_LABELS: ReadonlySet<string> = new Set([
  'Cancellation Notice',
  'Insurance Cancellation Notice',
  'Non-Renewal Notice'
]);

/**
 * Extracts the template document code (e.g. `A_IDCD`, `H_CNRS`) from a stored document filename or a
 * full S3 key. The code is the final hyphen-delimited token of the filename, upper-cased, with the
 * `BF_` prefix, the trailing `_CW_*` suffix, and a trailing two-letter state code stripped. Shared by
 * `generateFriendlyName` and the member-document eligibility checks so they can never disagree.
 */
export const getDocumentCode = (fileName: string): string => {
  const docIdWithoutExt =
    fileName // '2019-2-14-19-29-A_IDCD.pdf'
      .split('.'); // [2019-2-14-19-29-A_IDCD, pdf']
  let docId = docIdWithoutExt[0]
    .split('-') // ['2019', '2', '14', '19', '29', 'A_IDCD']
    .slice(-1)[0] // ['A_IDCD']
    .toUpperCase(); // 'A_IDCD'
  // also drop out "BF_" if it starts with that.
  docId = docId.replace('BF_', '');
  // handle case where id has _CW and ends with stuff after _CW
  docId = !docId.includes('_CW_') ? docId : docId.split('_CW_')[0].concat('_CW');
  // strip off _XY if it ends that way
  docId = docId.match(/_[A-Z][A-Z]$/) ? docId.replace(/_[A-Z][A-Z]$/, '') : docId;
  return docId;
};

/** The mapped friendly label for a document filename / S3 key, or `undefined` if the code is unknown. */
export const getDocumentFriendlyLabel = (fileName: string): string | undefined =>
  docIdToFriendlyName[getDocumentCode(fileName) as keyof typeof docIdToFriendlyName];

/**
 * Whether the document is a recognized, member-facing policy document (its code maps to a known
 * friendly label). The staff "Send to member" EMAIL channel is scoped to these so an unrecognized or
 * internal document is never emailed to a member (#36066).
 */
export const isRecognizedMemberDocument = (fileName: string): boolean =>
  getDocumentFriendlyLabel(fileName) !== undefined;

/**
 * Whether the document is a cancellation or non-renewal notice — the only class the Lob mailing path
 * supports, hence the only documents eligible for the "Send to member" LETTER channel (#36066).
 */
export const isCancellationOrNonRenewalDocument = (fileName: string): boolean => {
  const label = getDocumentFriendlyLabel(fileName);
  return label !== undefined && CANCELLATION_NON_RENEWAL_LABELS.has(label);
};

export const generateFriendlyName = (fileName: string) => getDocumentFriendlyLabel(fileName) || fileName;

export {
  type InvoiceChannel,
  type InvoiceRecord,
  decodeInvoiceMetadata,
  encodeInvoiceMetadata,
  invoiceChannelLabel
} from './invoice-metadata';
